export {
  BrandPage as default,
  getOmodaStaticProps as getStaticProps,
} from '@cinch-nx/landing-feature-brand-page'
